import { FC, useContext, useEffect, useState } from "react";
import TGButton from "src/components/ui/TGButton";
import { TestRegistryContext } from "../store/testRegistryContext";
import { setEditTest, setMinCorrectAnswerCount, setTest } from "../store/testRegistryActions";
import { updateItemRequest } from "src/modules/spItems/api";
import { useFormContext } from "react-hook-form";
import { testRegistry } from "src/api/config/notifications.config";

interface IProps {
  questions: any;
  shouldUpdateTestList: () => void;
}

export const EditTestFooter: FC<IProps> = ({ questions, shouldUpdateTestList }) => {
  const [isDirty, setIsDirty] = useState(false);
  const { watch, setValue } = useFormContext();
  const { state, dispatchTestRegistry } = useContext(TestRegistryContext);
  const minCorrectAnswersCount = watch("MinCorrectAnswersCount");
  const testName = watch("TestName");

  const closeTest = () => {
    dispatchTestRegistry(setEditTest(false));
    setValue("MinCorrectAnswersCount", state.minCorrectAnswersCount);
    shouldUpdateTestList();
  };

  useEffect(() => {
    if (+state.minCorrectAnswersCount !== +minCorrectAnswersCount || state.test.Title !== testName || `${questions.map((questionID: any) => questionID.ID)}` !== `${state.test.QuestionsID}`) {
      setIsDirty(true);
    } else {
      setIsDirty(false);
    }
  }, [minCorrectAnswersCount, testName, state.test, state.minCorrectAnswersCount, questions.map((questionID: any) => questionID.ID)]);

  const updateTest = () => {
    const questionsID = questions.map((questionID: any) => questionID.ID);

    updateItemRequest({
      listName: testRegistry,
      body: { ...state.test, Collections: state.test.Collections.ID, QuestionsID: questionsID, Title: testName, MinCorrectAnswerCount: +minCorrectAnswersCount },
      update: false
    });
    dispatchTestRegistry(setMinCorrectAnswerCount(minCorrectAnswersCount));
    dispatchTestRegistry(
      setTest({
        ...state.test,
        Title: testName,
        QuestionsID: questionsID
      })
    );
  };

  return (
    <div className="flex justify-between mt-5">
      <TGButton onClick={closeTest}>Отмена</TGButton>
      <div className="flex gap-[10px]">
        <TGButton color="bluedark" onClick={updateTest} disabled={!isDirty}>
          Сохранить
        </TGButton>
      </div>
    </div>
  );
};
